<template>
    <div>
        <el-row>
            <el-form ref="ruleForm" label-width="160px" label-position="right">
                <el-col :span="24">
                    <el-card shadow="never">
                        <!-- ///// filter pater //////  -->
                        <el-row :gutter="20">
                            <el-col class="text-md-left" :span="18">
                                <el-row class="filter-first-row">
                                    <el-col class="searchCustomer">
                                        <el-input
                                            placeholder="รหัสลูกค้า, ชื่อลูกค้าหรืออีเมล"
                                            v-model="searchText"
                                            @input="onSearch()"
                                        >
                                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                        </el-input>
                                    </el-col>
                                </el-row>
                                <el-row class="filter-second-row">
                                    <!-- subscription status -->
                                    <el-col class="dropdown-filter">
                                        <el-select
                                            v-model="filter.subscription_status"
                                            @change="onSearch()"
                                            placeholder="Subscription Status"
                                        >
                                            <el-option v-for="item in all_subscription_status"
                                                       :key="item.value" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </el-col>
                                    <!-- packages -->
                                    <el-col class="dropdown-filter">
                                        <el-select
                                            v-model="filter.subscription_package_id"
                                            @change="onSearch()"
                                            placeholder="Package"
                                        >
                                            <el-option :label="'ทุกแพ็คเกจ'" :value="0"></el-option>
                                            <el-option v-for="item in subscriptionPackages"
                                                       :key="item.id" :label="item.id +' - ' +item.name" :value="item.id"></el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col class="date-filter">
                                        <el-form-item label="สร้างออเดอร์ล่าสุด">
                                            <el-date-picker
                                                v-model="filter.datePickTo"
                                                type="daterange"
                                                format="dd / MM / yyyy"
                                                value-format="yyyy-MM-dd"
                                                range-separator="To"
                                                style="width: 100%;"
                                                start-placeholder="ระหว่างวันที่"
                                                end-placeholder="ถึงวันที่"
                                                :default-value="defaultDatePick"
                                                @change="onSearch()"
                                            >
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <!-- serach btn -->
                            <el-col :span="5" class="text-md-left">
                                <el-button type="primary" @click="onSearch()">ค้นหา</el-button>
                            </el-col>

                        </el-row>

                        <!-- ///// table part ////// -->
                        <el-row style="margin-top:10px">
                            <el-col class="text-md-left" :sm="24">
                                <el-table
                                    v-loading="loadingTable"
                                    :data="subscriptionList"
                                    stripe
                                    :default-sort="{prop: 'createdAt', order: 'descending'}"
                                    :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                                    style="width: 100%"
                                    ref="customerTable"
                                    :row-key="getRowKey"
                                    @selection-change="handleSelectionChange">
                                    <el-table-column v-model="subscriptionSelection" :reserve-selection="true" type="selection" align="center" width="55">
                                    </el-table-column>

                                    <el-table-column fixed prop="userCode" label="รหัสลูกค้า" width="120"></el-table-column>

                                    <el-table-column fixed label="ชื่อลูกค้า" width="200">
                                        <div class="text-md-left" slot-scope="scope">
                                            {{ scope.row.firstName }} {{ scope.row.lastName }}
                                        </div>
                                    </el-table-column>

                                    <el-table-column fixed prop="lastCreatedOrder" label="Last Created Order" width="160">
                                        <template slot-scope="scope">
                                            {{ scope.row.lastCreatedOrder | dayjs('format', 'YYYY-MM-DD HH:mm:ss') }}
                                        </template>
                                    </el-table-column>

                                    <el-table-column fixed prop="lastPickedOrder" label="Last Picked Up" width="160">
                                        <template slot-scope="scope">
                                            {{ scope.row.lastPickedOrder | dayjs('format', 'YYYY-MM-DD HH:mm:ss') }}
                                        </template>
                                    </el-table-column>

                                    <el-table-column fixed prop="currentOrderCount" label="Current Month"/>
                                    <el-table-column fixed prop="m1OrderCount" label="M-1"/>
                                    <el-table-column fixed prop="m2OrderCount" label="M-2"/>
                                    <el-table-column fixed prop="m3OrderCount" label="M-3"/>
                                    <el-table-column fixed prop="m4OrderCount" label="M-4"/>
                                    <el-table-column fixed prop="totalOrderCount" label="Total Orders"/>

                                    <!-- <el-table-column fixed="right" label="จัดการ" width="150">
                                        <template slot-scope="scope">
                                            <el-button :key="scope.$index" size="small" icon="el-icon-edit" type="warning" plain @click="showUserDetail(scope.row)"></el-button>
                                            <el-button :key="scope.$index+'-shop'" size="small" icon="el-icon-document" type="info" plain @click="showShop(scope.row)"></el-button>
                                        </template>
                                    </el-table-column> -->
                                </el-table>
                            </el-col>
                            <el-col style="margin-top:10px;">
                                <el-pagination
                                    @size-change="changeLimitPage"
                                    @current-change="changeCurrentPage"
                                    :current-page.sync="pagination.currentPage"
                                    :page-sizes="pagination.pageSizes"
                                    :page-size="10"
                                    layout="prev, pager, next, sizes"
                                    :total="pagination.allPage * pagination.limit">
                                </el-pagination>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
            </el-form>
        </el-row>

    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import onlineOperationUtility from '@/mixins/onlineOperationUtility.js'
import { AllSubscriptionStatus } from '@/components/Overview/FilterMaster.js'

export default {
    name: 'TransactionProfile',
    props: {},
    mixins: [onlineOperationUtility],
    data () {
        const today = this.$dayjs()
        const last30Day = this.$dayjs().subtract(1, 'month')
        const defaultDatePick = [last30Day, today]

        return {
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            searchText: '',
            filter: {
                subscription_status: 0,
                subscription_package_id: 0,
                datePickTo: [last30Day.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')]
            },
            defaultDatePick,
            all_subscription_status: AllSubscriptionStatus,
            loadingTable: false,
            subscriptionList: [],
            subscriptionSelection: null,
            subscriptionPackages: []
        }
    },
    created () {
        this.getPackage()
        this.fetchListTransaction()
    },
    methods: {
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchListTransaction()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.fetchListTransaction()
        },
        onSelectStatusFilter () {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.fetchListTransaction()
        },
        onSearch () {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.fetchListTransaction()

            this.$refs.customerTable.clearSelection()
        },
        async fetchListTransaction () {
            clearTimeout(this.timeoutSearch)
            this.timeoutSearch = setTimeout(async () => {
                this.loadingTable = true
                let param = {
                    search: this.searchText,
                    limit: this.pagination.limit,
                    offset: this.pagination.offset,
                    subscription_package_id: this.filter.subscription_package_id,
                    subscription_status: this.filter.subscription_status,
                    from: this.filter.datePickTo.length > 0 ? this.filter.datePickTo[0] : null,
                    to: this.filter.datePickTo.length > 0 ? this.filter.datePickTo[1] : null
                }
                // let res = await fgApi.user.getUserListOpt(param)
                let res = await fgApi.overview.getOverviewTransactionProfile(param)
                if (res.success) {
                    if (this.searchText === param.search) {
                        this.subscriptionList = res.data ? res.data : []
                        this.pagination.allPage = res.allPage
                    }
                }

                this.loadingTable = false
            }, 1000)
        },
        async getPackage () {
            try {
                let res = await fgApi.subscription.getPackage()
                if (res.status === 'success') {
                    this.subscriptionPackages = res.data
                }
            } catch (error) {
                console.log(error)
            }
        },
        handleSelectionChange (val) {
            this.subscriptionSelection = val
        },
        getRowKey (row) {
            return row.userId
        }
    }
}
</script>

<style lang="scss" scoped>
.filter-first-row {
    display: flex;

    .searchCustomer {
        margin-right: 5px;
    }

    .dropdown-filter {
        width: 300px;
        margin-left: 5px;
    }
}

.filter-second-row {
    display: flex;
    margin-top: 5px;
    margin-bottom: 5px;

    .dropdown-filter {
        width: 300px;
        margin-right: 5px;
    }

    .date-filter {
        margin-right: 5px;
    }
}

.table-column {
    min-width: 200px;
}

.btn-box {
    display: flex;
    justify-content: flex-end;

    .btn-export-box {
        margin-left: 16px;

        .btn-export {
            width: 90px;
            height: 40px;
        }
    }
}
</style>
